const kitchen = [
    {
        name: "Кухонные столы",
        img: "./images/category/кухонные столы.png"
        
        
    },
    {
        name: "Кухонные кресла",
        img: "./images/category/кухонные кресла.png"
    },

    { 
      name: "Барные стулья", 
      img: "./images/category/барные стулья.png"
    },
    { 
      name: "Украшения", 
      img: "./images/category/украшения.png"
    },
    
];

export default kitchen;
